// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file merchant/v1/public_catalog_api.proto (package merchant.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Product } from "./product_pb";

/**
 * @generated from message merchant.v1.CreateProductRequest
 */
export const CreateProductRequest = proto3.makeMessageType(
  "merchant.v1.CreateProductRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sku", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message merchant.v1.CreateProductResponse
 */
export const CreateProductResponse = proto3.makeMessageType(
  "merchant.v1.CreateProductResponse",
  () => [
    { no: 1, name: "product", kind: "message", T: Product },
  ],
);

